import { createFileRoute } from '@tanstack/react-router'
import { AlternativesPage, alternativesHead, type AlternativesData } from '@/components/alternatives-page'
import { MONITOR_LOCATIONS } from '@/lib/check-locations'

const data: AlternativesData = {
  tool: "UptimeRobot",
  slug: "uptimerobot",
  intro: "UptimeRobot offers a free plan of 50 monitors at 5-minute checks, with 30-second checks from its Team plan. If you want faster checks for less, or other features, here are alternatives.",
  alternatives: [
    {
      name: "Better Stack",
      description: "Uptime monitoring combined with on-call, incident management, logs, and status pages in one platform.",
      pricing: "Free (10 monitors), paid from $34/mo per responder",
      pros: ["On-call scheduling and incident management", "Unlimited phone and SMS alerts on paid plans", "Multi-location confirmation (3 of 4 locations by default)"],
      cons: ["Priced per responder, plus monitor packs", "More product than you need if you only want uptime checks"],
      url: "https://betterstack.com",
    },
    {
      name: "Uptrack",
      description: "Uptime monitoring with 30-second checks and alert confirmation. Pro includes 50 monitors for $3/mo.",
      pricing: "Free (5 monitors), Pro $3/mo, Team $20/mo, Business $79/mo",
      pros: ["30-second checks on every plan", "Alerts only after 2-5 consecutive failed checks", "Flat pricing with a 30-day money-back guarantee"],
      cons: ["Free plan is 5 monitors at 30 s from one location", MONITOR_LOCATIONS.alternativesCon, "No APM or logs"],
      url: "https://uptrack.app",
      isUptrack: true,
    },
    {
      name: "Pulsetic",
      description: "Status pages and uptime monitoring, with status page custom domains on every plan.",
      pricing: "Free (10 monitors), paid plans from Solo",
      pros: ["Status page custom domains on all plans, including free", "Up to 15 check regions on Team", "SMS, call, and WhatsApp alerts billed per message"],
      cons: ["Free plan checks every 5 minutes", "30-second checks start on the Team plan", "Teammates cost $8/mo each"],
      url: "https://pulsetic.com",
    },
    {
      name: "HetrixTools",
      description: "Uptime, blacklist, and server monitoring, with a free plan of 15 monitors at 1-minute checks.",
      pricing: "Free (15 monitors), Professional $9.95/mo",
      pros: ["Free plan with 15 monitors at 1-minute checks", "Blacklist and agent-based server monitoring", "Unlimited status pages on all plans"],
      cons: ["1-minute minimum interval on all plans", "Professional plan covers 30 monitors"],
      url: "https://hetrixtools.com",
    },
    {
      name: "Hyperping",
      description: "Uptime monitoring, browser checks, on-call, and status pages, checked from 18 regions.",
      pricing: "Free (20 monitors), Essentials $24/mo",
      pros: ["Multi-region confirmation before an outage opens", "Browser checks and built-in on-call", "20-second checks on the Business plan"],
      cons: ["30-second checks start at $24/mo (Essentials)", "Extra seats cost $7-12/mo each"],
      url: "https://hyperping.com",
    },
  ],
  comparisonTable: [
    { tool: "Better Stack", freePlan: "10 monitors", checkInterval: "3min (free), 30s (paid)", alertConfirmation: "Yes (multi-location)", startingPrice: "$34/mo per responder" },
    { tool: "Uptrack", freePlan: "5 monitors at 30s", checkInterval: "30s (all plans)", alertConfirmation: "Yes (2-5 consecutive)", startingPrice: "Free; Pro $3/mo" },
    { tool: "Pulsetic", freePlan: "10 monitors", checkInterval: "5min (free), 30s (Team)", alertConfirmation: "Not documented", startingPrice: "Solo plan (see site)" },
    { tool: "HetrixTools", freePlan: "15 monitors", checkInterval: "1min", alertConfirmation: "Yes (multi-location)", startingPrice: "$9.95/mo" },
    { tool: "Hyperping", freePlan: "20 monitors", checkInterval: "5min (free), 30s (Essentials)", alertConfirmation: "Yes (multi-region)", startingPrice: "$24/mo" },
  ],
}

export const Route = createFileRoute('/_site/alternatives/uptimerobot')({
  component: () => <AlternativesPage data={data} />,
  head: () => alternativesHead(data),
})
